import showBobtailModal from './showBobtailModal';
import BobtailModal from './BobtailModal';

export default BobtailModal;

export { showBobtailModal };
